import { TaskSubTicketStatus } from 'dy-frontend-http-repository/lib/modules/TaskSubTicket/resources/TaskSubTicketResource';

// A completed phase is never overdue however late it landed — flagging finished work adds
// noise to the list without giving anyone an action to take.
//
// Neither is a phase with no due date: there is no date for it to be late against, and reading
// "no deadline" as "already missed" would put a red date on work nobody has promised.
export const isSubTicketOverdue = (dueAt: string | null, status: TaskSubTicketStatus, nowMs: number): boolean => {
    if (status === 'complete') {
        return false;
    }

    if (!dueAt) {
        return false;
    }

    const dueAtMs = Date.parse(dueAt);
    if (!Number.isFinite(dueAtMs) || !Number.isFinite(nowMs)) {
        return false;
    }

    return dueAtMs < nowMs;
};
